import React from 'react';
import { Box, FormPreloader } from '@common-fe/common-fe';

import AppliedTo from './AppliedTo';

interface Props {
  isLoading?: boolean;
  roles?: string[];
  isModalMode?: boolean;
}

const FieldLevelAccessAppliedToSection: React.FC<Props> = ({
  isLoading = false,
  roles,
  isModalMode,
}) => {
  return (
    <Box
      round="container1Round"
      background="canvas"
      pad="l"
      data-testid="field-level-access"
      margin={{ top: 'l' }}
      border={{ size: 'small', color: 'border1' }}
    >
      {isLoading ? <FormPreloader count={2} /> : (
        <Box direction='column'>
          <AppliedTo
            roles={roles}
            isModalMode={isModalMode}
            isLoading={isLoading}
          />
        </Box>
      ) }
    </Box>
  );
};

export default FieldLevelAccessAppliedToSection;
